module.exports = __webpack_public_path__ + "static/media/fav-icon.3e151c0d.svg";